/**
 * Drawer featured products: on each menu open, pick data-bq-show at random from
 * the server-rendered pool, favouring the Wu Xing Movement of the Nuwa profile.
 * The pool can arrive later, so a MutationObserver backs the menu-open hook.
 */
(function () {
  'use strict';
  if (window.bqDrawerFeaturedInit) return;
  window.bqDrawerFeaturedInit = true;

  function shuffle(a) {
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i];
      a[i] = a[j];
      a[j] = t;
    }
    return a;
  }

  function mouvement() {
    try {
      var p = JSON.parse(localStorage.getItem('botaqi_profile'));
      return p && p.mouvement ? String(p.mouvement).toLowerCase() : null;
    } catch (e) {
      return null;
    }
  }

  function itemsOf(list) {
    return Array.prototype.slice.call(list.children).filter(function (el) {
      return el.classList && el.classList.contains('menu-drawer__featured-content-list-item');
    });
  }

  // Order the pool: Nuwa Movement products first (shuffled), then the
  // rest (shuffled). No profile: everything shuffled.
  function orderByProfile(items) {
    var mvt = mouvement();
    if (!mvt) return shuffle(items.slice());
    var hit = [];
    var rest = [];
    items.forEach(function (el) {
      var m = (el.getAttribute('data-bq-mvt') || '').toLowerCase();
      (m && m.indexOf(mvt) !== -1 ? hit : rest).push(el);
    });
    return shuffle(hit).concat(shuffle(rest));
  }

  // Pick `show` random products from the pool and place them first; hide
  // the rest. Reset the carousel to the start. Idempotent: replayable on each
  // open to rotate the selection.
  function rotate(list) {
    if (!list) return;
    var items = itemsOf(list);
    if (items.length < 2) return;
    var show = parseInt(list.getAttribute('data-bq-show'), 10);
    if (!show || show > items.length) show = items.length;

    var ordered = orderByProfile(items);
    var frag = document.createDocumentFragment();
    ordered.forEach(function (el, i) {
      el.style.display = i < show ? '' : 'none';
      frag.appendChild(el);
    });
    list.appendChild(frag);
    list.scrollLeft = 0;
    refreshChevron(list);
  }

  // Scroll chevron: one tap = one page (visible width ≈ 2 cards);
  // at the end, loops back to the start. Hidden if ≤ 2 visible cards.
  function visibleItems(list) {
    return itemsOf(list).filter(function (el) {
      return el.style.display !== 'none';
    });
  }

  function refreshChevron(list) {
    var wrap = list.closest('.menu-drawer__featured-content');
    var btn = wrap && wrap.querySelector('[data-bq-featured-next]');
    if (!btn) return;
    btn.hidden = visibleItems(list).length <= 2;
    btn.classList.remove('menu-drawer__featured-next--rewind');
  }

  function wireChevron(list) {
    if (!list || list.dataset.bqChevron) return;
    var wrap = list.closest('.menu-drawer__featured-content');
    var btn = wrap && wrap.querySelector('[data-bq-featured-next]');
    if (!btn) return;
    list.dataset.bqChevron = '1';

    function atEnd() {
      return list.scrollLeft + list.clientWidth >= list.scrollWidth - 4;
    }
    // Step = 2 cards (one page): distance between 2 consecutive visible cards
    // (width + gap) × 2. Scroll-snap then settles on the even card.
    function pageStep() {
      var it = visibleItems(list);
      if (it.length >= 2) {
        return (it[1].getBoundingClientRect().left - it[0].getBoundingClientRect().left) * 2;
      }
      return list.clientWidth;
    }
    btn.addEventListener('click', function () {
      var max = list.scrollWidth - list.clientWidth;
      if (list.scrollLeft >= max - 4) {
        list.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        list.scrollTo({ left: Math.min(max, list.scrollLeft + pageStep()), behavior: 'smooth' });
      }
    });
    list.addEventListener('scroll', function () {
      if (list._bqRaf) return;
      list._bqRaf = requestAnimationFrame(function () {
        list._bqRaf = 0;
        btn.classList.toggle('menu-drawer__featured-next--rewind', atEnd());
      });
    }, { passive: true });
  }

  function scan() {
    document.querySelectorAll('.menu-drawer__featured-content-list').forEach(function (list) {
      wireChevron(list);
      rotate(list);
    });
    hookOpen();
  }

  // Re-pick a selection on every menu open (the list can persist
  // between opens: without this hook the rotation would not replay).
  function hookOpen() {
    var details = document.querySelector('#Details-menu-drawer-container');
    if (!details || details.dataset.bqRotHook) return;
    details.dataset.bqRotHook = '1';
    var mo = new MutationObserver(function () {
      if (details.classList.contains('menu-open')) {
        document.querySelectorAll('.menu-drawer__featured-content-list').forEach(rotate);
      }
    });
    mo.observe(details, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }

  // Featured content injected later (Section Rendering API): rescan.
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (
          (n.classList && n.classList.contains('menu-drawer__featured-content-list')) ||
          (n.querySelector && n.querySelector('.menu-drawer__featured-content-list'))
        ) {
          scan();
          return;
        }
      }
    }
  });
  try {
    mo.observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();
